import { BookkeepingTransactionFilters, bookkeepingAdjustmentGroupToTypes } from '~/types/general-bookkeeping';
import { formatDateForAPI } from '~/utils/formatDate';
import {
  useAdjustmentGroupsFilter,
  useCashBookAmountRangeFilter,
  useDateFilter,
  useSearchFilter,
} from '~/views/bookkeeping/cash-book/cash-book-state';

const useGeneralBookkeepingCashBookQueryOptions = (): BookkeepingTransactionFilters => {
  const [dateRange] = useDateFilter();
  const [search] = useSearchFilter();
  const [cashBookAmountRange] = useCashBookAmountRangeFilter();
  const [adjustmentGroups] = useAdjustmentGroupsFilter();

  return {
    dateFrom: dateRange ? formatDateForAPI(dateRange.start) : null,
    dateTo: dateRange ? formatDateForAPI(dateRange.end) : null,
    search,
    cashBookAmountRange,
    adjustmentType: ['NONE', ...adjustmentGroups.flatMap((group) => bookkeepingAdjustmentGroupToTypes[group])],
  };
};
export default useGeneralBookkeepingCashBookQueryOptions;
